import type { DocumentListRow } from "~/OrdersQuotes/OrderListPage/useOrderListState";
import type { OrderData } from "~/OrdersQuotes/common/modelsV2";

export const isErrorEntry = (row: DocumentListRow<OrderData>) => {
  return row.data.soNumber === "-";
};

export const addStatusHover = (status: string) => {
  return status === "PR";
};
